import React, { Component } from "react";
import { connect } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import { Modal, Button, Form } from "@patternfly/react-core";
import Loader from "./../../Common/Loader/Loader";
import config from "../../../utils/config";
import MainViewer from "../../Common/Map/MainViewer";
import ToastNotification from "./../../Common/ToastNotification/ToastNotification";
import { navigate } from "@reach/router";
import ReactDatePicker from "react-datepicker";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Moment from "react-moment";
import moment from "moment";
class AddNewProject extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isModalOpen: false,

      fields: {},
      errors: {},
      IsLoader: false,
      ProjectName: "",
      Location: "",
      Status: "Unverified",
      userData: [],
      files: [],

      regexp: /^[0-9\b]+$/,

      hide: false,

      projectType: [],
      projectSubType: [],
      selectedprojectType: "",
      selectedprojectSubType: "",
      initiatedAndNew: "",
      typeList: [],
      initiatedAndNew: "",
      percentageCompleted: "",
      commonMastersList: [],
      notificationMessage: "",

      dateOfInitiation: "",
      estimatedProjectPeriod: "",
    };
    this.handleProjectType = this.handleProjectType.bind(this);
    this.handleNewAndInitiated = this.handleNewAndInitiated.bind(this);
    this.handleProjectSubType = this.handleProjectSubType.bind(this);
    this.handleEstimatedProjectPeriod =
      this.handleEstimatedProjectPeriod.bind(this);
    this.handleDate = this.handleDate.bind(this);

    this.mounted = true;
    this.handleModalToggle = () => {
      this.clearFields();
      this.setState(({ isModalOpen }) => ({
        isModalOpen: !isModalOpen,
        errors: {},
      }));
    };
  }

  componentDidMount() {
    this.mounted = true;

    this.GetCommonMasters();
  }

  handleNewAndInitiated(event) {
    this.setState({ initiatedAndNew: event.target.value });
  }
  handleDate(event) {
    if (this.mounted) this.setState({ dateOfInitiation: event.target.value });
  }

  handleEstimatedProjectPeriod(event) {
    this.setState({ estimatedProjectPeriod: event.target.value });
  }
  GetCommonMasters = () => {
    let url = `${config.API_HOST_URL}/api/Ecosystem/GetCommonMasters`;
    fetch(url, {
      method: "Get",
      headers: {
        WebsiteGuid: this.props.websiteGUID,
        LanguageGuid: this.props.languageGUID,
        Authorization: `Bearer ${this.props.token}`,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        var listOfType = data
          .filter((x) => x.type === "ProjectType")
          .map((x) => x.description);

        this.setState({
          commonMastersList: data,
          typeList: listOfType,
        });
      })
      .catch((error) => {
        console.log("Error in request", error);
      });
  };

  handleProjectType = (event) => {
    const value = event.target.value;
    // this.setState({projectSubType :this.state.commonMastersList.filter(x => x.type === event.target.value).map((item)});
    // this.setState({projectSubType :this.state.commonMastersList.filter(x=>x.type==="ProjectSubType", x=>x.mainGuId===event.target.value).find(x=>x.description)});

    if (event.target.name == "ddltype")
      this.setState({ selectedprojectType: event.target.value });
    //    {this.state.commonMastersList.filter(x => x.mainGuId === event.target.value).map((item) =>  this.setState({projectSubType :item}))}
    this.setState({
      projectSubType: this.state.commonMastersList.filter(
        (x) => x.mainGuId === event.target.value
      ),
    });
  };

  handleProjectSubType = (event) => {
    const value = event.target.value;
    if (event.target.name == "ddlsubtype")
      this.setState({ selectedprojectSubType: event.target.value });
  };

  componentWillUnmount() {
    this.mounted = false;
  }

  clearFields = (e) => {
    if (this.mounted) {
      this.setState({
        ProjectName: "",
        Location: "",
        ProjectType: "new",

        Status: "Unverified",
        files: [],

        typeList: "",
        initiatedAndNew: "",
        percentageCompleted: "",

        dateOfInitiation: "",
        estimatedProjectPeriod: "",
        selectedprojectType: "",
        selectedprojectSubType: "",
      });
    }
  };

  goBack = (e) => {
    window.history.back();
  };

  // This function do validate the Registration Form
  validateForm = (e) => {
    let fields;
    fields = {
      ProjectName: this.state.ProjectName,
      Location: this.state.Location,
      Status: "Unverified",

      estimatedProjectPeriod: this.state.estimatedProjectPeriod,
      selectedprojectType: this.state.selectedprojectType,
      selectedprojectSubType: this.state.selectedprojectSubType,
      percentageCompleted: this.state.percentageCompleted,

      initiatedAndNew: this.state.initiatedAndNew,
      dateOfInitiation: this.state.dateOfInitiation,
    };
    let errors = {};
    let formIsValid = true;
    if (!fields["ProjectName"]) {
      formIsValid = false;
      errors["ProjectName"] = "Enter Project Name.";
    }
    if (
      !fields["percentageCompleted"] &&
      this.state.initiatedAndNew == "Initiated Already"
    ) {
      formIsValid = false;
      errors["percentageCompleted"] = "Enter Percentage.";
    }
    if (
      !fields["dateOfInitiation"] &&
      this.state.initiatedAndNew == "Initiated Already"
    ) {
      formIsValid = false;
      errors["dateOfInitiation"] = "Enter Date.";
    }
    if (!fields["estimatedProjectPeriod"]) {
      formIsValid = false;
      errors["estimatedProjectPeriod"] = "Enter Estimated Project Period.";
    }

    if (!fields["selectedprojectType"]) {
      formIsValid = false;
      errors["selectedprojectType"] = "Enter Project Type.";
    }
    if (!fields["selectedprojectSubType"]) {
      formIsValid = false;
      errors["selectedprojectSubType"] = "Enter Project Sub-Type.";
    }
    if (!fields["initiatedAndNew"]) {
      formIsValid = false;
      errors["initiatedAndNew"] = "Enter  New or Initiated Already.";
    }
    if (!fields["Location"]) {
      formIsValid = false;
      errors["Location"] = "Enter Location.";
    }

    if (this.mounted) {
      this.setState({ errors: errors });
    }
    return formIsValid;
  };

  click = () => {
    this.props.parentMethod("All");
  };

  AddNewProject = (e) => {
    e.preventDefault();

    if (this.validateForm()) {
      if (this.mounted) {
        const formData = new FormData();

        formData.append("UserId", this.props.userData.userId);
        formData.append("ProjectName", this.state.ProjectName);

        formData.append("Status", "Unverified");
        formData.append("IsActive", true);
        formData.append("ProjectTypeGuId", this.state.selectedprojectType);
        formData.append(
          "ProjectSubTypeGuId",
          this.state.selectedprojectSubType
        );
        formData.append("NewOrInitiatedAlready", this.state.initiatedAndNew);
        formData.append("PercentageCompleted", this.state.percentageCompleted);
        formData.append(
          "EstimatedProjectPeriod",
          this.state.estimatedProjectPeriod
        );
        var dateofin = new Date(this.state.dateOfInitiation).toUTCString();
        formData.append("DateOfInitiation", dateofin);
        formData.append("Location", this.state.Location);
        let uri = `${config.API_HOST_URL}/api/projects/AddNewProjectPI`;
        let fetchOptions = {
          method: "POST",
          //body: JSON.stringify(UserDetail),
          body: formData,
          headers: {
            Authorization: `Bearer ${this.props.token}`,
            Accept: "application/json",
            ContentType: "multipart/form-data",
          },
        };
        this.setState({ IsLoader: true });
        fetch(uri, fetchOptions)
          .then((response) => {
            return response.json().then((data) => {
              if (data.success) {
                let errors = {};
                errors["message"] = data.message;
                if (this.mounted) {
                  this.setState({
                    errors: errors,
                    IsLoader: false,
                  });
                }
                this.setState({ notificationMessage: data.message });
                //  this.click();
                this.clearFields();
                // this.handleModalToggle();
                //alert(data.message);
                ToastNotification.ShowSuccess(data.message);
              } else {
                let errors = {};
                errors["message"] = data.message;
                if (this.mounted) {
                  this.setState({
                    errors: errors,
                    IsLoader: false,
                  });
                }
                ToastNotification.ShowSuccess(data.message);
              }
            });
          })
          .catch((error) => {
            if (this.mounted) {
              console.log(error);
              this.setState({
                errorMsg: error,
                IsLoader: false,
              });
            }
          });
      }
    }
  };

  // This function will set the state of input fields and validate them when user enters the value in input boxes

  handleUserInput = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    if (this.mounted) {
      this.setState({ [name]: value });
    }
  };
  handleAlphaInput = (e) => {
    const name = e.target.name;
    // let value = e.target.value;
    let value =
      e.target?.value.trim() && e.target?.value.replace(/[^a-zA-Z0-9]/gi, "");
    // const alphanumericRegex = /^[a-zA-Z0-9\s]+$/;
    // if (value === '' || alphanumericRegex.test(value)) {
    //   this.setState({ [name]: value });
    // }

    if (this.mounted) {
      this.setState({ [name]: value });
    } else {
      this.setState({
        ProjectName: "",
      });
    }
  };

  onddlselectprorequidoc = (e) => {
    if (this.mounted) {
      this.setState({
        ProjectRequiredDocuments: e.target.value,
      });
    }
  };
  render() {
    const { typeList, isModalOpen, isModalMapOpen } = this.state;
    return (
      <div>
        {this.state.IsLoader ? (
          <Loader />
        ) : (
          <div className="addpro_btn">
            <Button onClick={this.handleModalToggle}>
              Add Project <i className="fa fa-plus"></i>
            </Button>
            <Modal
              title="Create Project"
              isOpen={isModalOpen}
              onClose={this.handleModalToggle}
              className="addproject_modal"
              actions={[
                <Button
                  key="submit"
                  className="modal_btn submit_btn"
                  onClick={this.AddNewProject}
                >
                  Submit
                </Button>,
                <Button
                  key="cancel"
                  className="modal_btn cancel_btn"
                  onClick={this.handleModalToggle}
                >
                  Cancel
                </Button>,
              ]}
            >
              <div>
                <ul className="addproject_form">
                  <li className="form-group field addprobigfontlbl">
                    <input
                      required
                      pattern="[a-zA-Z0-9]+"
                      type="text"
                      id="proname"
                      placeholder="Enter Project Name"
                      name="ProjectName"
                      value={this.state.ProjectName}
                      onChange={(event) => this.handleAlphaInput(event)}
                    />
                    <label for="proname">
                      <sup className="mandatory">*</sup>Project Name
                    </label>
                    <div className="mandatory has-error">
                      {this.state.errors.ProjectName}
                    </div>
                  </li>

                  <li className="form-group field">
                    <select
                      value={this.state.selectedprojectType}
                      onChange={this.handleProjectType}
                      ref="selectedGroup"
                      name="ddltype"
                    >
                      <option value="" selected="selected">
                        Select{" "}
                      </option>
                      {this.state.commonMastersList
                        .filter((x) => x.type === "ProjectType")
                        .map((item) => (
                          <option value={item.mainGuId}>
                            {item.description}
                          </option>
                        ))}
                    </select>
                    <label for="baselocation">
                      <sup className="mandatory">*</sup>
                      Project Type
                    </label>
                    <div className="mandatory has-error">
                      {this.state.errors.selectedprojectType}
                    </div>
                  </li>
                  <li className="form-group field">
                    <select
                      value={this.state.selectedprojectSubType}
                      onChange={this.handleProjectSubType}
                      ref="selectedGroup"
                      name="ddlsubtype"
                    >
                      <option value="" selected="selected">
                        Select
                      </option>
                      {this.state.projectSubType
                        .filter((x) => x.type === "ProjectSubType")
                        .map((item) => (
                          <option value={item.subGuId}>
                            {item.description}
                          </option>
                        ))}
                    </select>
                    <label for="nameofhodorg">
                      <sup className="mandatory">*</sup>
                      Project Sub-type
                    </label>

                    <div className="mandatory has-error">
                      {this.state.errors.selectedprojectSubType}
                    </div>
                  </li>

                  <li className="form-group field">
                    <select
                      value={this.state.initiatedAndNew}
                      onChange={this.handleNewAndInitiated}
                      name="epperiod"
                    >
                      <option value="" selected="selected">
                        Select{" "}
                      </option>
                      <option>New </option>
                      <option>Initiated Already </option>
                    </select>
                    <label for="NGOHeadEmailAddress">
                      <sup className="mandatory">*</sup>
                      New or Initiated Already?
                    </label>
                    <div className="mandatory has-error">
                      {this.state.errors.initiatedAndNew}
                    </div>
                  </li>

                  {this.state.initiatedAndNew == "Initiated Already" && (
                    <div>
                      <li className="form-group field addprobigfontlbl">
                        <input
                          type="number"
                          min="0"
                          id="percentageCompleted"
                          name="percentageCompleted"
                          placeholder="Enter Percentage"
                          required
                          value={this.state.percentageCompleted}
                          onChange={(event) => this.handleUserInput(event)}
                        />
                        <label for="percentageCompleted">
                          {" "}
                          <sup className="mandatory">*</sup> Enter Percentage{" "}
                        </label>
                        <div className="mandatory has-error">
                          {this.state.errors.percentageCompleted}
                        </div>
                      </li>
                      <li className="form-group field">
                        <input
                          type="date"
                          name="date"
                          value={this.state.dateOfInitiation}
                          onChange={(event) => this.handleDate(event)}
                          onKeyDown={(e) => e.preventDefault()}
                        />

                        <label for="NGOHeadEmailAddress">
                          <sup className="mandatory">*</sup>
                          Date of Initiation
                        </label>
                        <div className="mandatory has-error">
                          {this.state.errors.dateOfInitiation}
                        </div>
                      </li>
                    </div>
                  )}
                  <li className="form-group field">
                    <select
                      value={this.state.estimatedProjectPeriod}
                      onChange={this.handleEstimatedProjectPeriod}
                      ref="selectedEpPeriod"
                      name="epperiod"
                    >
                      <option value="" selected="selected">
                        Select
                      </option>
                      <option>1{">"}=2</option>
                      <option>2{">"}=5</option>
                      <option>5{">"}=7</option>
                      <option>{">"}7</option>
                    </select>
                    <label for="NGOHeadEmailAddress">
                      <sup className="mandatory">*</sup>
                      Estimated Project Period (In years)
                    </label>
                    <div className="mandatory has-error">
                      {this.state.errors.estimatedProjectPeriod}
                    </div>
                  </li>
                  <li className="form-group field addprobigfontlbl">
                    <input
                      required
                      pattern="[a-zA-Z0-9]+"
                      type="text"
                      id="location"
                      placeholder="Enter Location"
                      name="Location"
                      value={this.state.Location}
                      onChange={(event) => this.handleAlphaInput(event)}
                    />
                    <label for="location">
                      <sup className="mandatory">*</sup>Location
                    </label>
                    <div className="mandatory has-error">
                      {this.state.errors.Location}
                    </div>
                  </li>
                </ul>
              </div>
              <div className="successmsgcont">
                {" "}
                <label> {this.state.notificationMessage} </label>{" "}
              </div>
            </Modal>
          </div>
        )}
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    token: state.configuration.token,
    userData: state.user.userData,
  };
}

export default connect(mapStateToProps)(AddNewProject);
